<template>
  <!-- <w-tooltip align-left>
    <template #activator="{ on }">
      <w-icon md v-on="on">
        mdi mdi-information
      </w-icon>
    </template>
LOL prova {{ infos }}
<span v-for="(item, index) in infos" :key="index">
  <span :class="item.class">{{ item.name }} </span>: <span> {{ item.info }}</span> <br>
</span>
</w-tooltip>-->
  <div class="tooltip">
    <span class="tooltiptext"> </span>
  </div>

  <!-- Modal (always) -->
  <w-icon class="cursor-pointer" md @click="showModal = true">
    mdi mdi-information-outline
  </w-icon>
  <w-dialog v-model="showModal" :width="320" persistent class="stati-in-info">
    <template #title>
      <span class="title3">Informazioni stati</span>
    </template>
    <div class="pa2 info-container">
      <div v-for="(item, index) in infos" :key="index" class="ma2">
        <span :class="item.class">{{ item.name }} </span>: <span> {{ item.info }}</span><br>
      </div>
    </div>
    <template #actions>
      <div class="spacer"></div>
      <w-button @click="showModal = false" color="primary">Chiudi</w-button>
    </template>
  </w-dialog>
</template>

<script>
import { ref, watch } from 'vue';

export default {
  props: {
    alignment: {
      type: String,
      default: null
    },
    infos: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  setup(props) {
    const localItems = ref([...props.infos]);
    const showModal = ref(false);

    watch(() => props.infos, (newItems) => {
      localItems.value = [...newItems];
    }, { deep: true });

    return { localItems, showModal };
  }
}
</script>
<style scoped>
.cursor-pointer {
  cursor: pointer;
}

.info-container {
  display: block;
  text-align: left;
  max-width: 280px;
  white-space: normal;
  word-break: break-word;
  max-height: calc(100dvh - 80px);
  overflow-y: auto;
}

.info-columns {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 4px 24px;
}

.info-section-header {
  grid-column: 1 / -1;
  font-weight: 700;
  margin-top: 8px;
  padding-bottom: 2px;
  border-bottom: 1px solid rgba(0,0,0,0.1);
}

.info-section-header:first-child {
  margin-top: 0;
}

.info-item {
  font-size: 0.82em;
  line-height: 1.25;
  padding: 2px 0;
}

/* Tooltip container */
.tooltip {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black;
}

/* Tooltip text ***
.tooltip .tooltiptext {
  visibility: hidden;
  width: 150px;
  background-color: black;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;

  /* Position the tooltip text - see examples below! ***
  position: absolute;
  z-index: 1000;
}

.tooltip .tooltiptext::after {
  content: " ";
  position: absolute;
  bottom: 100%;
  /* At the top of the tooltip ***
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent black transparent;
}

/* Show the tooltip text when you mouse over the tooltip container ***
.tooltip:hover .tooltiptext {
  visibility: visible;
}*/
/**this is ignored for some reason is owerwritten by library
.w-tooltip .w-tooltip--bottom{
  z-index: 10001;
  max-width: 1001px;
}*/
.wrapper{
  position: relative;
  max-width: min(90vw, 1100px);
  z-index: 10001;
}

@media (max-height: 900px) {
  .info-item {
    font-size: 0.78em;
    line-height: 1.2;
    padding: 1px 0;
  }
  .info-section-header {
    margin-top: 4px;
    font-size: 0.9em;
  }
}

@media (max-width: 700px) {
  .info-columns {
    grid-template-columns: 1fr;
  }
  .info-item {
    font-size: 0.78em;
  }
}

.stati-in-info {
  z-index: 99999 !important;
}
</style>

<style>
.w-tooltip__tooltip {
  max-width: min(90vw, 900px) !important;
}
</style>
